import React from "react";
import { Typography } from "@mui/material";
import ColorLink from "./ColorLink";

const EM_DASH = "—";

// A colour as a SpecRow value: a link to what that colour is worth, or an em dash when the stone
// has none. `colorKey` is the estimator's name for the colour, which differs from the label for
// every system but GIA ("Flat 35047" for a flat of 35047).
const ColorValue = ({
  label,
  colorKey,
}: {
  label: string | number | null | undefined;
  colorKey: string;
}) =>
  label ? (
    <ColorLink
      label={String(label)}
      color={colorKey}
      style={{ color: "primary.main", fontWeight: 500 }}
    />
  ) : (
    <Typography component="span" sx={{ color: "text.secondary" }}>
      {EM_DASH}
    </Typography>
  );

export default ColorValue;
